<template>
  <div>
    <div class="row col-12 mt-3 ml-0 pl-0 mr-0 pr-0">
      <div class="col-3">
        <label for="status_list_selos_gerenc"
               class="label">
          Status
        </label>

        <v-select id="status_list_selos_gerenc"
                  v-model="pesquisa.status"
                  :options="pesquisa.tiposStatus"
                  :reduce="status => status.value"
                  class="form-control form-control-sm"
                  name="status_list_selos_gerenc"
                  placeholder="Selecione" />
      </div>

      <div class="col-3">
        <label for="tipo_data_list_selos_gerenc"
               class="label">
          Tipo de data
        </label>

        <v-select id="tipo_data_list_selos_gerenc"
                  v-model="pesquisa.tipoData"
                  :options="pesquisa.tiposDatas"
                  :reduce="data => data.value"
                  class="form-control form-control-sm"
                  name="tipo_data_list_selos_gerenc"
                  placeholder="Selecione"
                  @input="changeTipoData" />
      </div>

      <div class="col-6">
        <div class="label">
          Data
        </div>

        <div class="d-inline-flex align-items-top">
          <div>
            <input id="inicio_data_list_selos_gerenc"
                   v-model="pesquisa.dataInicio"
                   v-validate="{ required: !!pesquisa.tipoData }"
                   type="date"
                   name="inicio_data_list_selos_gerenc"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('inicio_data_list_selos_gerenc')}"
                   :disabled="!pesquisa.tipoData">
            <span v-if="errors.has('inicio_data_list_selos_gerenc')"
                  class="invalid-feedback">
              {{ errors.first("inicio_data_list_selos_gerenc") }}
            </span>
          </div>

          <p class="ml-2 mr-2 mt-1">
            até
          </p>

          <div>
            <input id="fim_data_list_selos_gerenc"
                   v-model="pesquisa.dataFim"
                   v-validate="{ required: !!pesquisa.tipoData }"
                   type="date"
                   name="fim_data_list_selos_gerenc"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('fim_data_list_selos_gerenc')}"
                   :disabled="!pesquisa.tipoData">
            <span v-if="errors.has('fim_data_list_selos_gerenc')"
                  class="invalid-feedback">
              {{ errors.first("fim_data_list_selos_gerenc") }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row col-12 mt-2 ml-0 pl-0 mr-0 pr-0">
      <div class="col-4">
        <label for="matricula_list_selos_gerenc"
               class="label">
          Número da matrícula
        </label>

        <input id="matricula_list_selos_gerenc"
               v-model="pesquisa.matricula"
               v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
               type="text"
               name="matricula_list_selos_gerenc"
               class="form-control form-control-sm">
      </div>

      <div class="col-8">
        <label for="nome_reg_list_selos_gerenc"
               class="label">
          Nome do registrado
        </label>

        <input id="nome_reg_list_selos_gerenc"
               v-model="pesquisa.nomeRegistrado"
               type="text"
               name="nome_reg_list_selos_gerenc"
               class="form-control form-control-sm">
      </div>
    </div>

    <div class="row col-12 mt-4 mb-0 ml-3 pl-0 mr-0 pr-3 d-inline-flex">
      <label class="label mr-3">
        Tipo de registro
      </label>

      <b-form-checkbox id="filtro_todos_reg_list_selos_gerenc"
                       v-model="pesquisa.filtroTodosRegistros"
                       name="filtro_todos_reg_list_selos_gerenc"
                       :value="true"
                       class="mr-0"
                       @change="selecionaTodosTipoRegistro()">
        Todos
      </b-form-checkbox>

      <b-form-checkbox v-for="(tiposRegistros, index) in pesquisa.iconsTiposRegistros"
                       :id="`tipo_registro_${tiposRegistros.text}_${index}`"
                       :key="index"
                       v-model="pesquisa.tiposRegistros"
                       class="ml-4"
                       :name="`tipo_registro_${tiposRegistros.text}_${index}`"
                       :value="tiposRegistros.value"
                       @change="changeTipoRegistro(tiposRegistros.value)">
        <IconSvg v-if="tiposRegistros.icon"
                 :icon="tiposRegistros.icon"
                 class="icon--sm m-0 p-0 TipoRegistro_tipos_icon" />
        {{ tiposRegistros.text }}
      </b-form-checkbox>
    </div>

    <div class="row col-12 ml-3 pl-0 mr-0 pr-3">
      <small v-if="!pesquisa.tiposRegistros.length"
             class="alertText">
        Informe o tipo de registro que deseja filtrar
      </small>
    </div>

    <div class="row col-12 mt-3 ml-0 pl-0 mr-0 pr-0">
      <div class="col-4">
        <label for="selo_list_selos_gerenc"
               class="label">
          Selo
        </label>

        <input id="selo_list_selos_gerenc"
               v-model="pesquisa.numSelo"
               type="text"
               name="selo_list_selos_gerenc"
               class="form-control form-control-sm">
      </div>

      <div class="col-8 d-inline-flex align-items-end justify-content-end">
        <button class="btn btn-sm btn-primary px-4"
                @click="filtrarSelosVinculadores()">
          Filtrar
        </button>
      </div>
    </div>

    <div v-if="selosVinculadores.length">
      <div class="row col-12 ml-0 mr-3 mt-3 mb-3">
        <div class="col-sm-4 col-12 pl-0 pr-0 d-inline-flex align-self-center">
          <b-form-checkbox id="selecionaTodosSelosVinculadores"
                           v-model="selecionaTodosSelosVinculadores"
                           name="selecionaTodosSelosVinculadores"
                           :value="true"
                           :disabled="!(selosVinculadores.filter(seloVinculador => seloVinculador.status === 'Vinculação a ser enviada').length > 0)"
                           @change="selecionaTodosSelos()">
            Selecionar todos os selos vinculadores
          </b-form-checkbox>
        </div>

        <div class="col-sm-4 col-12 pl-0 pr-0 paginate d-inline-flex justify-content-center align-items-center">
          <p class="paginate_text small d-inline-block mt-0">
            Página
          </p>

          <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                  :class="{ 'inactive': (Number(paginacao.page) === 1) }"
                  :disabled="(Number(paginacao.page) === 1)"
                  type="button"
                  title="Página anterior"
                  @click="paginaAnterior()">
            <svg class="paginate_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + arrowLeft.id" />
            </svg>
          </button>

          <p class="paginate_text small d-inline-block mt-0">
            <select v-model="paginacao.page"
                    class="form-control form-control-sm"
                    @change="selecionaPagina(paginacao.page)">
              <option v-for="(value, index) in paginacao.lastPage"
                      :key="`option_paginate_selos_gerenc_${ index }_${ _uid }`">
                {{ value }}
              </option>
            </select>
          </p>

          <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                  :class="{ 'inactive': Number(paginacao.page) === paginacao.lastPage }"
                  :disabled="(Number(paginacao.page) === paginacao.lastPage)"
                  type="button"
                  title="Próxima página"
                  @click="proximaPagina()">
            <svg class="paginate_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + arrowRight.id" />
            </svg>
          </button>

          <p class="paginate_text small d-inline-block mt-0">
            {{ `de ${paginacao.lastPage}` }}
          </p>
        </div>

        <div class="col-sm-4 col-12 pl-0 pr-0">
          <div class="d-inline-flex align-items-center w-100">
            <label for="mostrar_selos_gerenc"
                   class="paginate_text_default">
              Mostrar:
            </label>

            <select id="mostrar_selo_gerenc"
                    v-model="paginacao.perPage"
                    class="form-control form-control-sm ml-1"
                    style="width:15%"
                    @change="filtrarSelosVinculadores()">
              <option v-for="(value, index) in [10,20,30,40,50]"
                      :key="index"
                      :value="value">
                {{ value }}
              </option>
            </select>

            <label for="ordenar_selos_gerenc"
                   class="ml-2 paginate_text_default">
              Ordernar por:
            </label>

            <select id="ordenar_selos_gerenc"
                    v-model="pesquisa.orderBy"
                    class="form-control form-control-sm ml-1"
                    style="width:40%"
                    @change="filtrarSelosVinculadores()">
              <option v-for="(order, index) in paginacao.order"
                      :key="index"
                      :value="order.value">
                {{ order.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div v-for="(seloVinculador, index) in selosVinculadores"
           :key="`selo_vinculador_${seloVinculador.num_selo}_${index}`"
           class="BoxVinculador mt-3 mb-2 ml-3 mr-3">
        <div class="BoxVinculador_header ml-0 mr-0">
          <div class="row BoxVinculador_header_title ml-0 mr-0"
               :class="{
                 'BoxVinculador_header_green_title': seloVinculador.status === 'Vinculação enviada',
                 'BoxVinculador_header_red_title': seloVinculador.status === 'Revisar vinculação',
                 'BoxVinculador_header_yellow_title': seloVinculador.status === 'Vinculação a ser enviada'
               }">
            <div v-if="seloVinculador.status === 'Vinculação a ser enviada'"
                 class="BoxVinculador_columnCheckBox col-12 d-flex align-items-center">
              <b-form-checkbox :id="`checkbox_${seloVinculador.num_selo}_${index}`"
                               v-model="seloVinculador.check"
                               :name="`checkbox_${seloVinculador.num_selo}_${index}`"
                               @change="selecionaSeloVinculador(index)" />
            </div>

            <div v-else-if="seloVinculador.status === 'Revisar vinculação'"
                 class="ml-2 d-flex align-items-center">
              <IconSvg icon="alert"
                       class="icon--sm icons--white" />
            </div>

            <div :class="['Revisar vinculação', 'Vinculação a ser enviada'].indexOf(seloVinculador.status) >= 0 ? 'BoxVinculador_columnNomeAndMatricula' : 'col-sm-12'"
                 class="col-12 pl-2 pt-1 pb-1">
              <span v-for="(pessoa, index) in seloVinculador.registro.pessoas.filter(pessoa => pessoa.relacao_registro === 'REGISTRADO')"
                    :key="`pessoa_selo_vinculador_${pessoa.pessoa_id}_${index}`">
                <span v-if="index > 0"
                      class="ml-2">
                  {{ 'e' }}
                </span>

                <span :class="index === 0 ? 'ml-1' : 'ml-2'">
                  {{ pessoa.nome || pessoa.nome_antigo }}
                </span>
              </span>

              <div class="row ml-0 pl-1">
                <small class="mt-1 mr-1">
                  matrícula:
                </small>

                <span>{{ seloVinculador.registro.matricula | maskMatricula }}</span>
              </div>
            </div>

            <div v-if="['Revisar vinculação', 'Vinculação a ser enviada'].indexOf(seloVinculador.status) >= 0"
                 class="BoxVinculador_columnPendencias col-12 ml-0 mr-0 pr-0">
              <div class="row w-100 d-inline-flex justify-content-end mt-2 mb-2 pt-1 pb-1 mr-0">
                <button class="btn btn-sm btn-outline-light"
                        @click="openBoxSeloVinculador(index)">
                  Pendências ({{ seloVinculador.vinculacoes.filter(vinculacao => !vinculacao.envio_vinculacao_tj).length }})
                </button>
              </div>
            </div>
          </div> 
        </div>

        <div class="row no-gutters col-12 mt-2">
          <div class="BoxVinculador_columnSeloVinculador col-12">
            <div class="BoxVinculador_detailsBoxInfo">
              <h2 class="BoxVinculador_detailsBoxInfo_title">
                Selo vinculador
              </h2>

              <div class="BoxVinculador_detailsBoxInfo_text">
                {{ seloVinculador.num_selo }}
              </div>
            </div>
          </div>

          <div class="BoxVinculador_columnDataVinculacao col-12 ml-3">
            <div class="BoxVinculador_detailsBoxInfo">
              <h2 class="BoxVinculador_detailsBoxInfo_title">
                Data e hora vinculação
              </h2>

              <div class="BoxVinculador_detailsBoxInfo_text">
                {{ seloVinculador.dataVinculacaoFormatada }}
              </div>
            </div>
          </div>

          <div class="col-12"
               :class="seloVinculador.status === 'Vinculação a ser enviada' ? 'ml-2 BoxVinculador_columnStatusEnviar mr-2' : 'ml-3 BoxVinculador_columnStatusDefault mr-4'">
            <div class="BoxVinculador_detailsBoxInfo">
              <h2 class="BoxVinculador_detailsBoxInfo_title">
                Status
              </h2>

              <div class="BoxVinculador_detailsBoxInfo_text">
                {{ seloVinculador.status }}
              </div>
            </div>
          </div>

          <div class="col-sm-1 col-12"
               :class="seloVinculador.status === 'Vinculação a ser enviada' ? 'mr-3' : 'mr-4'">
            <div class="BoxVinculador_detailsBoxInfo">
              <h2 class="BoxVinculador_detailsBoxInfo_title">
                Data registro
              </h2>

              <div class="BoxVinculador_detailsBoxInfo_text">
                {{ seloVinculador.dataRegistroFormatada }}
              </div>
            </div>
          </div>

          <div class="col-12"
               :class="seloVinculador.tipoRegistroFormatado === 'Habilitação de Casamento' ? 'BoxVinculador_columnTipoRegistroHab' : 'BoxVinculador_columnTipoRegistroDefault'">
            <div class="BoxVinculador_detailsBoxInfo">
              <h2 class="BoxVinculador_detailsBoxInfo_title">
                Tipo de registro
              </h2>

              <div class="BoxVinculador_detailsBoxInfo_text">
                {{ seloVinculador.tipoRegistroFormatado }}
              </div>
            </div>
          </div>

          <div class="BoxVinculador_columnLivro col-12"
               :class="seloVinculador.tipoRegistroFormatado === 'Habilitação de Casamento' ? 'ml-1' : 'ml-2'">
            <div class="BoxVinculador_detailsBoxInfo">
              <h2 class="BoxVinculador_detailsBoxInfo_title">
                Livro
              </h2>

              <div class="BoxVinculador_detailsBoxInfo_text">
                {{ seloVinculador.registro.livro.num_livro }}
              </div>
            </div>
          </div>

          <div class="BoxVinculador_columnFolha col-12 ml-1"
               :class="seloVinculador.tipoRegistroFormatado === 'Habilitação de Casamento' ? 'ml-1' : 'ml-2'">
            <div class="BoxVinculador_detailsBoxInfo">
              <h2 class="BoxVinculador_detailsBoxInfo_title">
                Folha
              </h2>

              <div class="BoxVinculador_detailsBoxInfo_text">
                {{ seloVinculador.registro.folha }}
              </div>
            </div>
          </div>

          <div class="BoxVinculador_columnTermo col-12 ml-1"
               :class="seloVinculador.tipoRegistroFormatado === 'Habilitação de Casamento' ? 'ml-1' : 'ml-2'">
            <div class="BoxVinculador_detailsBoxInfo">
              <h2 class="BoxVinculador_detailsBoxInfo_title">
                Termo
              </h2>

              <div class="BoxVinculador_detailsBoxInfo_text">
                {{ seloVinculador.registro.termo }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="seloVinculador.openBox">
          <div v-if="seloVinculador.status === 'Vinculação enviada'"
               class="row no-gutters col-12 mt-2">
            <table class="Listagem">
              <tr>
                <th class="Listagem_width_selo_vinculado">
                  <span class="BoxVinculador_detailsBoxInfo_title">
                    {{ seloVinculador.vinculacoes.filter(vinculacao => vinculacao.envio_vinculacao_tj).length > 1 ? 'Selos vinculados' : 'Selo vinculado' }}
                  </span>
                </th>

                <th class="Listagem_width_descricao">
                  <span class="BoxVinculador_detailsBoxInfo_title">
                    {{ seloVinculador.vinculacoes.filter(vinculacao => vinculacao.envio_vinculacao_tj).length > 1 ? 'Descrição dos atos vinculados' : 'Descrição do ato vinculado' }}
                  </span>
                </th>
              </tr>

              <tr v-for="(vinculacao, indexVinculacao) in seloVinculador.vinculacoes.filter(vinculacao => vinculacao.envio_vinculacao_tj)"
                  :key="`selos_vinculados_${vinculacao.seloVinculacao.num_selo}_${indexVinculacao}`"
                  class="BoxVinculador_detailsBoxInfo_line_height"
                  :class="{ 'Listagem_border_bottom': (indexVinculacao < seloVinculador.vinculacoes.filter(vinculacao => vinculacao.envio_vinculacao_tj).length - 1) }">
                <td class="d-inline-flex">
                  {{ vinculacao.seloVinculacao.num_selo }}
                </td>

                <td>
                  {{ vinculacao.seloVinculacao.seloItemOs.ordemServicoItem.custa.ato }}
                </td>
              </tr>
            </table>
          </div>

          <div v-if="['Revisar vinculação', 'Vinculação a ser enviada'].indexOf(seloVinculador.status) >= 0">
            <div class="row no-gutters mt-3 ml-3 mr-3 borderTopAndBottom pt-1 pb-1">
              <h5>
                {{ seloVinculador.vinculacoes.filter(vinculacao => !vinculacao.envio_vinculacao_tj).length === 1 ? 'Pendência:' : 'Pendências:' }}
              </h5>

              <span class="ml-2 marginTopTextVinculacaoPendente">
                {{ seloVinculador.vinculacoes.filter(vinculacao => !vinculacao.envio_vinculacao_tj).length }} 
                {{ seloVinculador.vinculacoes.filter(vinculacao => !vinculacao.envio_vinculacao_tj).length === 1 ? 'vinculação' : 'vinculações' }}
                nesse selo vinculador para {{ seloVinculador.status === 'Revisar vinculação' ? 'ajustar' : 'enviar ao TJ' }}
              </span>
            </div>
            
            <div class="row no-gutters col-12 mt-2">
              <table class="Listagem">
                <tr>
                  <th class="Listagem_width_selo_vinculado">
                    <span class="BoxVinculador_detailsBoxInfo_title">
                      {{ seloVinculador.vinculacoes.filter(vinculacao => !vinculacao.envio_vinculacao_tj).length > 1 ? 'Selos vinculados' : 'Selo vinculado' }}
                    </span>
                  </th>

                  <th :class="seloVinculador.status === 'Revisar vinculação' ? 'Listagem_width_descricao_pendencia_erro' : 'Listagem_width_descricao_pendencia'">
                    <span class="BoxVinculador_detailsBoxInfo_title">
                      {{ seloVinculador.vinculacoes.filter(vinculacao => !vinculacao.envio_vinculacao_tj).length > 1 ? 'Descrição dos atos vinculados' : 'Descrição do ato vinculado' }}
                    </span>
                  </th>

                  <th v-if="seloVinculador.status === 'Revisar vinculação'"
                      class="Listagem_width_ajuste" />
                </tr>

                <tr v-for="(vinculacao, indexVinculacao) in seloVinculador.vinculacoes.filter(vinculacao => !vinculacao.envio_vinculacao_tj)"
                    :key="`selos_vinculados_pendente_${vinculacao.seloVinculacao.num_selo}_${indexVinculacao}`"
                    class="BoxVinculador_detailsBoxInfo_line_height">
                  <td style="vertical-align: baseline;"
                      :class="{ 'Listagem_border_top': (indexVinculacao > 0) }">
                    {{ vinculacao.seloVinculacao.num_selo }}
                  </td>

                  <td :class="{ 'Listagem_border_top': (indexVinculacao > 0) }">
                    {{ vinculacao.seloVinculacao.seloItemOs.ordemServicoItem.custa.ato }}
                  </td>

                  <td v-if="indexVinculacao === 0 && seloVinculador.status === 'Revisar vinculação'"
                      class="Listagem_remove_border_bottom d-inline-flex align-items-start justify-content-start">
                    <button class="btn btn-sm btn-primary px-4"
                            @click="ajustar(seloVinculador)">
                      Ajustar
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="mt-2 row no-gutters">
          <button class="BoxVinculador_openDetails w-100 text-center"
                  @click="openBoxSeloVinculador(index)">
            <svg class="BoxVinculador_openDetails_icon icon--xxs mt-1 mb-1"
                 :class="{ 'BoxVinculador_rodate_button': seloVinculador.openBox }"
                 role="presentation">
              <use :xlink:href="'#' + arrowDown.id" />
            </svg>
          </button>
        </div>
      </div>

      <div class="row col-12 ml-0 mr-3 mt-4 mb-3">
        <div class="col-sm-12 col-12 pl-0 pr-0 paginate d-inline-flex justify-content-center align-items-center">
          <p class="paginate_text small d-inline-block mt-0">
            Página
          </p>

          <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                  :class="{ 'inactive': (Number(paginacao.page) === 1) }"
                  :disabled="(Number(paginacao.page) === 1)"
                  type="button"
                  title="Página anterior"
                  @click="paginaAnterior()">
            <svg class="paginate_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + arrowLeft.id" />
            </svg>
          </button>

          <p class="paginate_text small d-inline-block mt-0">
            <select v-model="paginacao.page"
                    class="form-control form-control-sm"
                    @change="selecionaPagina(paginacao.page)">
              <option v-for="(value, index) in paginacao.lastPage"
                      :key="`option_paginate_selos_gerenc_${ index }_${ _uid }`">
                {{ value }}
              </option>
            </select>
          </p>

          <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
                  :class="{ 'inactive': Number(paginacao.page) === paginacao.lastPage }"
                  :disabled="(Number(paginacao.page) === paginacao.lastPage)"
                  type="button"
                  title="Próxima página"
                  @click="proximaPagina()">
            <svg class="paginate_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + arrowRight.id" />
            </svg>
          </button>

          <p class="paginate_text small d-inline-block mt-0">
            {{ `de ${paginacao.lastPage}` }}
          </p>
        </div>
      </div>

      <div class="ml-3 mb-3 CumprirTarefas_width col-12 CumprirTarefas_action d-inline-flex justify-content-end align-items-center p-0 m-0 p-4 mt-2">
        <button class="btn btn-sm CumprirTarefas_cumprir px-4"
                :disabled="!(selosVinculadores.filter(seloVinculador => seloVinculador.status === 'Vinculação a ser enviada' && seloVinculador.check).length)"
                @click="cumprirTarefas()">
          <IconSvg icon="done"
                   class="icon--sm icon_done" />
          Cumprir todas as selecionadas
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  /* assets */
  import arrowDown from "@/assets/icons/arrow-down.svg?sprite"
  import arrowLeft from '@/assets/icons/arrow-left.svg?sprite'
  import arrowRight from '@/assets/icons/arrow-right.svg?sprite'

  /* services */
  import SelosService from "@/services/Registros/SelosService"

  export default {
    name: 'ListagemSelosGerenciador',
    data () {
      return {
        // icons
        arrowLeft,
        arrowRight,
        arrowDown,

        // controla a pesquisa
        pesquisa: {
          status: null,
          tiposStatus: [
            {
              label: 'Todas não cumpridas',
              value: 'NAO_CUMPRIDA'
            },
            {
              label: 'Todas cumpridas',
              value: 'CUMPRIDA'
            }
          ],
          tipoData: null,
          tiposDatas: [
            {
              label: 'Data Registro',
              value: 'DATA_REGISTRO'
            },
            {
              label: 'Data Vinculação',
              value: 'DATA_VINCULACAO'
            }
          ],
          dataInicio: null,
          dataFim: null,
          matricula: null,
          nomeRegistrado: null,
          filtroTodosRegistros: true,
          iconsTiposRegistros: [
            {
              text: 'Nascimento',
              value: 'N',
              icon: 'nascimento'
            },
            {
              text: 'Casamento',
              value: 'C',
              icon: 'engagement'
            },
            {
              text: 'Habilitação de Casamento',
              value: 'D',
              icon: 'engagement'
            },
            {
              text: 'Óbito',
              value: 'O',
              icon: 'flower'
            }
          ],
          tiposRegistros: ['N', 'C', 'CR', 'D', 'O', 'NT'],
          selo: null,
          orderBy: null
        },
        paginacao: {
          page: 1,
          perPage: 10,
          lastPage: 1,
          order: [
            { label: 'Selecione', value: null },
            { label: 'Data Vinculação', value: 'DATA_VINCULACAO' },
            { label: 'Data Registro', value: 'DATA_REGISTRO' }
          ]
        },
        selosVinculadores: [],
        selecionaTodosSelosVinculadores: false
      }
    },
    watch: {
      'pesquisa.tiposRegistros': function (newVal) {
        if (!newVal.length) {
          this.pesquisa.filtroTodosRegistros = false
          return
        }

        if (newVal.length === 6) {
          this.pesquisa.filtroTodosRegistros = true
        }
      }
    },
    methods: {
      selecionaTodosTipoRegistro () {
        this.pesquisa.filtroTodosRegistros = !this.pesquisa.filtroTodosRegistros

        this.pesquisa.tiposRegistros = this.pesquisa.filtroTodosRegistros ? ['N', 'C', 'CR', 'D', 'O', 'NT'] : []
      },
      changeTipoData (tipoData) {
        if (!tipoData) {
          this.pesquisa.dataInicio = null
          this.pesquisa.dataFim = null
        }
      },
      changeTipoRegistro (tipoRegistro) {
        if (['N', 'D'].indexOf(tipoRegistro) >= 0) return

        const indexTipoRegistro = this.pesquisa.tiposRegistros.findIndex(tipoReg => tipoReg === tipoRegistro)

        if (indexTipoRegistro >= 0) {
          // Retiramos o tipo C ou O
          this.pesquisa.tiposRegistros.splice(indexTipoRegistro, 1)
          
          const indexTipoRegistroAdicional = this.pesquisa.tiposRegistros.findIndex(tipoReg => tipoReg === (tipoRegistro === 'C' ? 'CR' : 'NT'))

          // Retiramos o tipo CR ou NT
          if (indexTipoRegistroAdicional >= 0) {
            this.pesquisa.tiposRegistros.splice(indexTipoRegistroAdicional, 1)
          }
        } else {
          // Adicionamos o tipo C ou O
          this.pesquisa.tiposRegistros.push(tipoRegistro)

          // Adicionamos o tipo CR ou NT
          this.pesquisa.tiposRegistros.push(tipoRegistro === 'C' ? 'CR' : 'NT')
        }
      },
      filtrarSelosVinculadores () {
        this.$validator.validateAll().then(async resp => {
          if (!resp || !this.pesquisa.tiposRegistros.length) return

          try {
            loader({ text: 'Aguarde...', active: true })

            const params = {
              page: this.paginacao.page,
              perPage: this.paginacao.perPage,
              statusTarefa: this.pesquisa.status,
              tipoData: this.pesquisa.tipoData,
              dataInicio: this.pesquisa.dataInicio,
              dataFim: this.pesquisa.dataFim,
              matricula: this.pesquisa.matricula ? this.pesquisa.matricula.replaceAll(' ', '') : null,
              nomeRegistrado: this.pesquisa.nomeRegistrado,
              tiposRegistros: this.pesquisa.tiposRegistros,
              numSelo: this.pesquisa.numSelo,
              orderBy: this.pesquisa.orderBy
            }

            const { data, lastPage } = await SelosService.getSelosVinculadores(params)
            this.selosVinculadores = data
            this.paginacao.lastPage = lastPage
            this.selecionaTodosSelosVinculadores = false

            if (!this.selosVinculadores.length) {
              loader({ text: '', active: false })

              objSwal.info.title = ''
              objSwal.info.text = 'Não existem vinculações de acordo com os filtros utilizados'
              objSwal.info.html = ''

              await Swal.fire(objSwal.info)

              setTimeout(() => {
                const btnConfirm = document.querySelector('.swal2-confirm')

                if (btnConfirm) btnConfirm.focus()
              }, 200)

              return
            }

            for (const seloVinculador of this.selosVinculadores) {
              for (const vinculacao of seloVinculador.vinculacoes) {
                if (vinculacao.seloVinculador) {
                  // Formatamos a data da vinculação
                  seloVinculador.dataVinculacaoFormatada = moment(vinculacao.data_vinculacao).format('DD/MM/YYYY - HH:mm')
                  seloVinculador.dataVinculacaoFormatada = seloVinculador.dataVinculacaoFormatada.replace(':', 'h')

                  seloVinculador.dataVinculacaoToWindowOpen = moment(vinculacao.data_vinculacao).format('DD-MM-YYYY-HH-mm-ss')

                  seloVinculador.data_vinculacao = vinculacao.data_vinculacao

                  // Adicionamos o status
                  if (!vinculacao.envio_vinculacao_tj && !vinculacao.erro_vinculacao_tj) {
                    seloVinculador.status = 'Vinculação a ser enviada'
                  } else if (!vinculacao.envio_vinculacao_tj && vinculacao.erro_vinculacao_tj) {
                    seloVinculador.status = 'Revisar vinculação'
                  } else if (vinculacao.envio_vinculacao_tj && vinculacao.data_envio_vinculacao_tj && !vinculacao.erro_vinculacao_tj) {
                    seloVinculador.status = 'Vinculação enviada'
                  }
                }
              }

              if (seloVinculador.status === 'Vinculação a ser enviada') {
                seloVinculador.check = false
              }

              // Formatamos a data do registro
              seloVinculador.dataRegistroFormatada = moment(seloVinculador.registro.data_registro).format('DD/MM/YYYY')

              // Formatamos o tipo de registro
              switch (seloVinculador.registro.tipo_registro) {
              case 'N': seloVinculador.tipoRegistroFormatado = 'Nascimento'; break
              case 'C': seloVinculador.tipoRegistroFormatado = 'Casamento'; break
              case 'CR': seloVinculador.tipoRegistroFormatado = 'Casamento Religioso'; break
              case 'D': seloVinculador.tipoRegistroFormatado = 'Habilitação de Casamento'; break
              case 'O': seloVinculador.tipoRegistroFormatado = 'Óbito'; break
              case 'NT': seloVinculador.tipoRegistroFormatado = 'Natimorto'; break
              }

              // Abrimos o box
              seloVinculador.openBox = false

              /**
               * Percorremos os selos e verificamos de qual tipo pertence.
               * Adicionamos as informações referentes ao resumo
               */
              if (seloVinculador.registro.obito) {
                seloVinculador.nameResumo = 'obito'
                seloVinculador.resumoId = seloVinculador.registro.obito.obito_id
              }

              if (seloVinculador.registro.nascimento) {
                seloVinculador.nameResumo = 'nascimento'
                seloVinculador.resumoId = seloVinculador.registro.nascimento.nascimento_id
              }

              if (seloVinculador.registro.casamento) {
                seloVinculador.nameResumo = 'casamento'
                seloVinculador.resumoId = seloVinculador.registro.casamento.casamento_id
              }

              if (seloVinculador.registro.habilitacaoCasamento) {
                seloVinculador.nameResumo = 'habilitar-casamento'
                seloVinculador.resumoId = seloVinculador.registro.habilitacaoCasamento.habilitacao_casamento_id
              }
            }
            
            loader({ text: '', active: false })
          } catch (e) {
            loader({ text: '', active: false })

            objSwal.error.title = ''
            objSwal.error.text = 'Não foi possível obter as vinculações'
            objSwal.error.html = ''

            await Swal.fire(objSwal.error)

            setTimeout(() => {
              const btnCancel = document.querySelector('.swal2-cancel')

              if (btnCancel) btnCancel.focus()
            }, 200)
          }
        })
      },
      openBoxSeloVinculador (index) {
        this.selosVinculadores[index].openBox = !this.selosVinculadores[index].openBox

        this.selosVinculadores = [...this.selosVinculadores]
      },
      ajustar (seloVinculador) {
        const url = `${window.location.origin}/${seloVinculador.nameResumo}/resumo/${seloVinculador.resumoId}?` +
          `mostrarSelos=true&seloVinculador=${seloVinculador.num_selo}&dataVinculacao=${seloVinculador.dataVinculacaoToWindowOpen}`

        window.open(url)
      },
      selecionaTodosSelos () {
        this.selecionaTodosSelosVinculadores = !this.selecionaTodosSelosVinculadores

        for (const seloVinculador of this.selosVinculadores.filter(seloVinculador => seloVinculador.status === 'Vinculação a ser enviada')) {
          seloVinculador.check = this.selecionaTodosSelosVinculadores
        }
      },
      selecionaSeloVinculador (index) {
        this.selosVinculadores[index].check = !this.selosVinculadores[index].check

        const selosParaEnviar = this.selosVinculadores.filter(seloVinculador => seloVinculador.status === 'Vinculação a ser enviada')

        if (!this.selosVinculadores[index].check && selosParaEnviar.every(selo => !selo.check)) {
          this.selecionaTodosSelosVinculadores = false
        }

        this.selosVinculadores = [...this.selosVinculadores]
      },
      paginaAnterior () {
        this.paginacao.page = Number(this.paginacao.page) - 1

        return this.filtrarSelosVinculadores()
      },
      selecionaPagina (page = 1) {
        this.paginacao.page = Number(page)

        return this.filtrarSelosVinculadores()
      },
      proximaPagina () {
        this.paginacao.page = Number(this.paginacao.page) + 1

        return this.filtrarSelosVinculadores()
      },
      async cumprirTarefas () {
        const selosParaCumprir = this.selosVinculadores.filter(seloVinculador => seloVinculador.status === 'Vinculação a ser enviada' && seloVinculador.check)
        
        if (!selosParaCumprir.length) return

        loader({ text: 'Aguarde...', active: true })

        try {
          const vinculacoesComErro = []

          for (const seloParaCumprir of selosParaCumprir) {
            const data = {
              numSeloVinculador: seloParaCumprir.num_selo,
              dataVinculacao: moment(seloParaCumprir.data_vinculacao).format('YYYY-MM-DD HH:mm:ss')
            }

            const { vinculacoes } = await SelosService.enviarVinculacoesPendentesTJ(data)

            const erroVinculacao = vinculacoes.filter(vinculacao => vinculacao.erro_vinculacao_tj)

            if (erroVinculacao.length) {
              vinculacoesComErro.push(erroVinculacao)
            }
          }

          let texto = 'Tarefas cumpridas com sucesso!'

          if (vinculacoesComErro.length) {
            texto = vinculacoesComErro.length === 1 ? 'Ocorreu erro com alguma tarefa. ' : 'Ocorreu erros com algumas tarefas. '
            texto += 'Para verificar localize as tarefas em vermelho na lista e clique ajustar para mais informações.'
          }

          objSwal.info.title = ''
          objSwal.info.text = texto
          objSwal.info.html = ''

          await Swal.fire(objSwal.info).then(() => {
            this.selecionaTodosSelosVinculadores = false

            this.filtrarSelosVinculadores()
          })

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)
        } catch (e) {
          loader({ text: '', active: false })

          objSwal.error.title = ''
          objSwal.error.text = 'Não foi possível cumprir as tarefas. Tente novamente.'
          objSwal.error.html = ''

          await Swal.fire(objSwal.error)

          setTimeout(() => {
            const btnCancel = document.querySelector('.swal2-cancel')

            if (btnCancel) btnCancel.focus()
          }, 200)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .TipoRegistro {
    &_tipos {
      font-size: 16px;
      font-weight: normal;
      color: #000000;

      &_icon {
        width: 20px;
        height: 20px;
      }
    }
  }

  .alertText {
    color: #ed0909;
  }

  .BoxVinculador {
    box-shadow: 0 0 pxToRem(1) $color-dark;

    &_header {
      font-size: 18px;
      font-weight: 450;
      color: white;

      &_green_title {
        background-color: $water-green-color;
      }

      &_red_title {
        background-color: #8b0000;
      }

      &_yellow_title {
        background-color: #7f7e14;
      }
    }

    &_columnCheckBox {
      -webkit-box-flex: 0;
      flex: 0 0 3%;
      max-width: 3%;
    }

    &_columnNomeAndMatricula {
      -webkit-box-flex: 0;
      flex: 0 0 82%;
      max-width: 82%;
    }

    &_columnPendencias {
      -webkit-box-flex: 0;
      flex: 0 0 15%;
      max-width: 15%;
    }

    &_detailsBoxInfo {
      &_title,
      &_text {
        font-size: pxToRem(15);
        margin-bottom: pxToRem(4);
      }

      &_title {
        border-bottom: pxToRem(1) solid;
        display: inline-block;
      }

      &_line_height {
        line-height: 1.7;
      }
    }

    &_columnSeloVinculador {
      -webkit-box-flex: 0;
      flex: 0 0 20%;
      max-width: 20%;
    }

    &_columnDataVinculacao {
      -webkit-box-flex: 0;
      flex: 0 0 15%;
      max-width: 15%;
    }

    &_columnStatusDefault {
      -webkit-box-flex: 0;
      flex: 0 0 12%;
      max-width: 12%;
    }

    &_columnStatusEnviar {
      -webkit-box-flex: 0;
      flex: 0 0 16%;
      max-width: 16%;
    }

    &_columnTipoRegistroDefault {
      -webkit-box-flex: 0;
      flex: 0 0 11%;
      max-width: 11%;
    }

    &_columnTipoRegistroHab {
      -webkit-box-flex: 0;
      flex: 0 0 17%;
      max-width: 17%;
    }

    &_columnLivro {
      -webkit-box-flex: 0;
      flex: 0 0 5%;
      max-width: 5%;
    }

    &_columnFolha {
      -webkit-box-flex: 0;
      flex: 0 0 5%;
      max-width: 5%;
    }

    &_columnTermo {
      -webkit-box-flex: 0;
      flex: 0 0 6%;
      max-width: 6%;
    }

    &_openDetails {
      background-color: rgba($color-dark, 0.2);
      border: none;
      cursor: pointer;
      bottom: 0;
      left: 0;
      max-height: pxToRem(20);
      right: 0;
      transition: background-color 0.15s linear;

      &_icon {
        outline: none;
        vertical-align: baseline;
      }

      &:hover,
      &:focus {
        background-color: rgba($color-dark, 0.4);
        outline: none;

        .BoxVinculador_openDetails_icon {
          fill: $color-white;
          transition: transform 0.15s linear;
        }
      }
    }

    &_rodate_button {
      transform: rotate(180deg);
    }
  }

  .Listagem {
    width: 100%;
    font-size: pxToRem(15);
    
    &_width_selo_vinculado {
      width: 21.4%;
    }
   
    &_width_descricao {
      width: 79.6%;
    }

    &_width_descricao_pendencia_erro {
      width: 74.6%;
    }

    &_width_descricao_pendencia {
      width: 79.6%;
    }

    &_width_ajuste {
      width: 5%
    }

    &_border_bottom {
      border-bottom: 1px dashed rgba(38, 38, 38, 0.4);
    }

    &_border_top {
      border-top: 1px dashed rgba(38, 38, 38, 0.4);
    }
  }

  .borderTopAndBottom {
    border-top: pxToRem(1) solid;
    border-bottom: pxToRem(1) solid;
  }

  .marginTopTextVinculacaoPendente {
    margin-top: 0.12rem !important
  }

  .paginate {
    &_padding_label_pagina {
      padding-left: 20.5%
    }

    &_text {
      font-size: pxToRem(14);
      font-weight: 500;
      margin-bottom: 0;
    }

    &_text_default {
      font-weight: 500;
      margin-bottom: 0;
    }

    &_btn {
      &.inactive {
        .paginate_icon {
          fill: $color-gray;
        }
      }
    }
  }

  .CumprirTarefas {
    &_width {
      -webkit-box-flex: 0;
      flex: 0 0 97.4%;
      max-width: 97.4%;
    }

    &_action {
      border: solid 1px #707070;
      background: #ffffff;
      position: sticky;
      bottom: 10px;
      z-index: 2;
    }

    &_label {
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }

    &_tipos {
      font-size: 16px;
      font-weight: normal;
      color: #000000;

      &_icon {
        width: 18px;
        height: 18px;
      }
    }

    &_cumprir {
      border: solid 1px #205e3b;
      background: #205e3b;
      font-size: 16px;
      font-weight: normal;
      text-align: center;
      color: #ffffff;
      fill: #FFFFFF;
    }

    &_cumprir:hover {
      color: #FFFFFF;
    }
  }
</style>